/* RESPONSIBLE TEAM: team-standalone */

import Platform from './platform';
import { IntegrationState, StandalonePlatform } from '../constants';
import type ApplicationInstance from '@ember/application/instance';
import FreshdeskConversationExtractionRow from './component-data/freshdesk/conversation-extraction-row';
import FreshdeskConversationExcerpt from './component-data/freshdesk/conversation-excerpt';
import GenericOnboardingGuideStep from './component-data/generic/onboarding-guide-step';
import GenericRequestAccessData from './component-data/generic/request-access';

export default class FreshdeskPlatform extends Platform {
  constructor(owner: ApplicationInstance) {
    super(owner);
  }

  get componentData(): Platform['componentData'] {
    return {
      'conversation-extraction': FreshdeskConversationExtractionRow,
      'conversation-excerpt': new FreshdeskConversationExcerpt(this),
      'knowledge-hub-modal': null,
      'onboarding-guide-step': new GenericOnboardingGuideStep(this),
      'request-access': new GenericRequestAccessData(this),
    } as const;
  }

  get isConnected() {
    return false;
  }

  get hasInstalledCopilot() {
    return false;
  }

  get historicalSyncingEnabled() {
    return false;
  }

  get finIsLive() {
    return false;
  }

  get finIsPaused() {
    return false;
  }

  get showAnalyzeSectionConnectCta() {
    return false;
  }

  get connectionState() {
    return IntegrationState.NotConfigured;
  }

  get icon() {
    return 'freshdesk' as const;
  }

  get platformKey() {
    return StandalonePlatform.Freshdesk;
  }
}
